import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import { convertCentsToPrice } from '@footykids/common';
import { FkaData } from '../../generated/graphql';

interface FKADataProps {
    FKAData: FkaData;
}

const FKAData: React.FC<FKADataProps> = ({ FKAData }) => {
    return (
        <React.Fragment>
            <Col sm='6'>
                <Card>
                    <CardBody>
                        <div className='d-flex align-items-center mb-3'>
                            <div className='avatar-xs me-3'>
                                <span className='avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18'>
                                    <i className='bx bx-dollar-circle' />
                                </span>
                            </div>
                            <h5 className='font-size-14 mb-0'>FKA Total Payment</h5>
                        </div>
                        <div className='text-muted mt-4'>
                            <h4>RM {convertCentsToPrice(FKAData.payments.currentTotalPayment)}</h4>
                            <div className='d-flex'>
                                <span className='text-truncate'>Total For Current Month:</span>
                                <span className='ms-2'>RM {convertCentsToPrice(FKAData.payments.currentMonthTotalPayment)}</span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Col sm='6'>
                <Card>
                    <CardBody>
                        <div className='d-flex align-items-center mb-3'>
                            <div className='avatar-xs me-3'>
                                <span className='avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18'>
                                    <i className='bx bx-id-card' />
                                </span>
                            </div>
                            <h5 className='font-size-14 mb-0'>FKA Total Student</h5>
                        </div>
                        <div className='text-muted mt-4'>
                            <h4>{FKAData.totalStudents} Student</h4>
                            <div className='d-flex'>
                                <span className='text-truncate'>Current Student Registered in FKA</span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default FKAData;
